const en = {
  "lines": [
    "Psst! Have you found me yet?",
    "Boo! Just checking on you.",
    "Don't tell anyone I'm here…",
    "I smell waffles somewhere…",
    "Have you seen my waterfall?",
    "Shh… I'm hiding from the troll hunters!",
    "Keep scrolling — I'm watching you!",
    "Is it 1 February yet?"
  ],
  "giant": [
    "HELLO DOWN THERE!",
    "Who's scrolling on my bridge?",
    "I'm not big. You're small."
  ],
  "golden": "You spotted the golden troll! Only a lucky few ever see me.",
  "goldenTag": "Legendary"
};

export default en;
